import { createMuiTheme } from '@material-ui/core/styles';

export const baseColor = '#003366';
export const fontFamily = 'Lato,sans-serif';

export const primary = {
  main: baseColor,
  dark: baseColor,
  light: '#0AC1A7',
  contrastText: '#ffffff',
  listBackground: '#d26a6b',
};

export const secondary = {
  main: '#D81159',
  dark: baseColor,
  light: '#D81159',
  contrastText: '#ffffff',
  listBackground: '#F9FBA6',
};

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
    fontSize: 12,
    fontFamily: [fontFamily].join(','),
    h3: {
      "&.appTitle": {
        marginBottom: 24,
      },
    },
  },
  palette: {
    primary,
    secondary,
  },
  overrides: {
    MuiAppBar: {
      root: {
        height: '80px'
      }
    },
    MuiToolbar: {
      root: {
        padding: '10px !important',
        justifyContent: 'space-between'
      },
    },
    MuiTableRow: {
      root: {
        '&.compact': {
          height: 32
        }
      }
    },
    MuiCheckbox: {
      colorSecondary: {
        '&$checked': {
          color: secondary.main
        }
      },
    },
    MuiFormControlLabel: {
      root: {
        fontSize: '12px',
        fontFamily: fontFamily,
        marginTop: '-0.5rem'
      }
    },
    MuiTab: {
      root: {
        border: '2px solid rgba(255,255,255,0)',
        borderRadius: 36,
      }
    },
    MuiButton: {
      contained: {
        "&$containedPrimary": {
          "&:hover": {
            color: '#fff'
          }
        }
      }
    },
    MuiTabs: {
      fixed: {
        width: '40%',
      },
    },
    MuiChip: {
      outlinedPrimary: {
        border: "1px solid #A9A9A9"
      },
      colorSecondary: {
        color: '#000',
        backgroundColor: secondary.listBackground
      }
    },
    MuiSlider: {
      track: {
        backgroundColor: primary.main
      },
      thumb: {
        backgroundColor: primary.light,
      },
      mark: {
        height: 16,
        width: 1,
        marginTop: -7,
        backgroundColor: '#bfbfbf',
      },
      markActive: {
        backgroundColor: primary.main
      },
      markLabelActive: {
        color: primary.main
      }
    }
  }
});

export default theme;